import React from "react";

/** 마이페이지 목록 빈 상태 공통 아이콘 */
export const MyPageEmptyIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M8 13.6C8 10.2397 8 8.55953 8.65396 7.27606C9.2292 6.14708 10.1471 5.2292 11.2761 4.65396C12.5595 4 14.2397 4 17.6 4H30.4C33.7603 4 35.4405 4 36.7239 4.65396C37.8529 5.2292 38.7708 6.14708 39.346 7.27606C40 8.55953 40 10.2397 40 13.6V34.4C40 37.7603 40 39.4405 39.346 40.7239C38.7708 41.8529 37.8529 42.7708 36.7239 43.346C35.4405 44 33.7603 44 30.4 44H17.6C14.2397 44 12.5595 44 11.2761 43.346C10.1471 42.7708 9.2292 41.8529 8.65396 40.7239C8 39.4405 8 37.7603 8 34.4V13.6Z"
      fill="#D4D4D8"
    />
    <path
      d="M32 22H16M24 30H16M32 14H16M40 13.6V34.4C40 37.7603 40 39.4405 39.346 40.7239C38.7708 41.8529 37.8529 42.7708 36.7239 43.346C35.4405 44 33.7603 44 30.4 44H17.6C14.2397 44 12.5595 44 11.2761 43.346C10.1471 42.7708 9.2292 41.8529 8.65396 40.7239C8 39.4405 8 37.7603 8 34.4V13.6C8 10.2397 8 8.55953 8.65396 7.27606C9.2292 6.14708 10.1471 5.2292 11.2761 4.65396C12.5595 4 14.2397 4 17.6 4H30.4C33.7603 4 35.4405 4 36.7239 4.65396C37.8529 5.2292 38.7708 6.14708 39.346 7.27606C40 8.55953 40 10.2397 40 13.6Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
